import { CapacitorHttp } from "@capacitor/core";
import { baseUrl, requestOptions } from "./api";
import { CapacitorHttpAuth, getCookies } from "./auth";
import { useQuery } from "react-query";

export const useGetMeQuery = () => {
  return useQuery({
    queryKey: ["getMe"],
    queryFn: async () => {
      let response = await CapacitorHttpAuth({
        url: `${baseUrl}/driver/me`,
        method: "GET",
      });
      return response.data;
    },
  });
};
